import {ChallengeScenarioAfterAction, ChallengeScenarioAfterActionTarget} from "../../../schema";
import {getCurrentScenario, getMaxLevel} from "../selectors";
import {PlayerReduxState} from "../types";
import {_next} from "../utils";

export default function finishScenario(state: PlayerReduxState): PlayerReduxState {
  const current = getCurrentScenario(state);

  if (current.isMain) {
    // next level
    return {
      ...state,
      level: state.level + 1,
      scenarioIndex: 0,
      index: -1,
      mainScenarioLastIndex: -1,
      scenarioStack: [],
      exposedActions: [],
      finishedScenarios: [],
    };
  } else {
    const finishedScenarioId = getCurrentScenario(state).id;
    let newState: PlayerReduxState & {finishedScenarios: string[]} = {...state, finishedScenarios: []};

    const afterTarget = current.afterActionTarget;
    let scenarioIndex = 0;
    let index = state.mainScenarioLastIndex;
    let chosenBranches;
    let last;
    let scenarioStack = state.scenarioStack.filter((s) => s.index !== null);
    switch (afterTarget) {
      case ChallengeScenarioAfterActionTarget.PREVIOUS:
        state.scenarioStack = scenarioStack;
        last = scenarioStack.pop();

        if (last) {
          scenarioIndex = last.scenarioIndex;
          index = last.index!;
          chosenBranches = last.chosenBranches;
        }
        break;

      case ChallengeScenarioAfterActionTarget.MAIN:
        chosenBranches = scenarioStack.length !== 0 ? scenarioStack[0].chosenBranches : undefined;
        state.scenarioStack = [];
      // falls through

      default:
        scenarioIndex = 0;
        index = state.mainScenarioLastIndex;
        break;
    }

    switch (current.afterAction) {
      case ChallengeScenarioAfterAction.RETURN:
        newState = {
          ...state,
          scenarioIndex: scenarioIndex,
          index: index,
          exposedActions: [],
          finishedScenarios: [],
          chosenBranches: new Set(chosenBranches),
        };
        break;
      case ChallengeScenarioAfterAction.NEXT:
        newState = finishToNextAction(state, scenarioIndex, index);
        break;
      case ChallengeScenarioAfterAction.NEXT_SCENARIO:
        scenarioIndex = current.nextScenarioIndex;
        newState = {
          ...state,
          index: 0,
          scenarioStack: [...state.scenarioStack, {scenarioIndex: getCurrentScenario(state).index, index: null}],
          finishedScenarios: [],
          scenarioIndex: scenarioIndex,
        };
        break;
      case ChallengeScenarioAfterAction.INTERRUPT:
        state["interrupted"] = true;
        newState = {...state, finishedScenarios: []};
        break;
      case ChallengeScenarioAfterAction.FINISH:
        newState = {
          ...state,
          scenarioIndex: 0,
          level: getMaxLevel(state) + 1,
          finishedScenarios: [],
        };
        break;
      default:
        console.error("Invalid ChallengeScenarioAfterAction");
        break;
    }

    return {...newState, finishedScenarios: [finishedScenarioId, ...newState.finishedScenarios]};
  }
}

function finishToNextAction(state: PlayerReduxState, scenarioIndex: number, actionIndex: number): PlayerReduxState {
  let previousOrMainNextIndex = _next(
    getCurrentScenario({...state, scenarioIndex: scenarioIndex}).actions,
    state.level,
    actionIndex,
  );

  let newState;
  if (previousOrMainNextIndex === undefined) {
    newState = finishScenario({...state, scenarioIndex: scenarioIndex});
  } else {
    newState = {
      ...state,
      scenarioIndex: scenarioIndex,
      index: previousOrMainNextIndex,
      finishedScenarios: [],
      exposedActions: [],
    };
  }

  return newState;
}
